import { render, staticRenderFns } from "./ApproveUserToken.vue?vue&type=template&id=35c215c6"
import script from "./ApproveUserToken.vue?vue&type=script&lang=js"
export * from "./ApproveUserToken.vue?vue&type=script&lang=js"
import style0 from "./ApproveUserToken.vue?vue&type=style&index=0&id=35c215c6&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports